import React from "react";
import "./Bill.scss";
import formatNumberWithCommas from "../format/formatNumberWithCommas";

export const ComponentToPrint = React.forwardRef(({ billData }, ref) => (
  <div ref={ref} className="main-layout-bill">
    <h2 className="font-brand">{billData.Brand}</h2>
    <h6 className="font-sub-infor">{billData.Address}</h6>
    <h6 className="font-sub-infor">{billData.Phone}</h6>
    <span className="front-line-star">{billData.Line}</span>
    <h3 className="front-bill-name">{billData.Bill}</h3>
    <table className="table-bill">
      <thead>
        <tr>
          <th className="custome-width-name font-head-table ">Tên</th>
          <th className="custome-center custome-width-quantity font-head-table ">
            Giá
          </th>
          <th className="custome-center custome-width-quantity font-head-table ">
            SL
          </th>
          <th className="custome-right font-head-table">Tổng</th>
        </tr>
      </thead>
      <tbody>
        {billData.OrderList.map((item, index) => (
          <tr key={index}>
            <td>{item.name}</td>
            <td className="custome-center">
              {formatNumberWithCommas(item.price)}
            </td>
            <td className="custome-center">{item.totalItem}</td>
            <td className="custome-right">
              {formatNumberWithCommas(item.totalPrice)}
            </td>
          </tr>
        ))}
      </tbody>
      <tbody>
        <tr>
          <td>Thời Gian</td>
          <td className="custome-center">
            {formatNumberWithCommas(billData.PriceOfTime)}
          </td>
          <td className="custome-center">{billData.TotalTime}</td>
          <td className="custome-right">
            {formatNumberWithCommas(billData.PriceOfTotalTime)}
          </td>
        </tr>
      </tbody>
    </table>
    <div className="frame-qr-total-bill">

      <div className="frame-qr">
        <img
          src={`https://img.vietqr.io/image/MB-0001120490029-qr_only.png?amount=${billData.TotalPayment}&addInfo=${billData.qrContent}&accountName=Chau%20Hoai%20Vu`}
          alt=""
        />
      </div>

      <div className="frame-square-total-payment-billDetails">
        <h4 className="front-total-price-billDetails">
          Tổng Tiền : {formatNumberWithCommas(billData.TotalPayment)} vnđ
        </h4>
        <h6>{billData.Date}</h6>
        <h6>{billData.Debt}</h6>
      </div>

    </div>
    <h4 className="front-line-star">{billData.Line}</h4>
    <h6 className="font-sub-infor-bye">{billData.Goodbye}</h6>
    <h6 className="font-sub-infor-bye">{billData.SubGoodbye}</h6>
  </div>
));
